
import React from 'react';
import { X, ShieldCheck, Lock, Eye, FileText } from 'lucide-react';

interface PrivacyModalProps {
  onClose: () => void;
}

const PrivacyModal: React.FC<PrivacyModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[150] bg-stone-900/60 backdrop-blur-md flex items-center justify-center p-6 animate-in fade-in duration-300">
      <div 
        className="bg-[#fcfbf7] w-full max-w-2xl max-h-[85vh] rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col animate-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-8 border-b border-stone-200 flex justify-between items-center bg-white">
          <div className="flex items-center gap-3">
            <div className="bg-amber-100 p-2 rounded-lg text-amber-700">
              <ShieldCheck size={20} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-stone-900 uppercase tracking-tighter">Política de Privacidad</h2>
              <p className="text-[10px] text-stone-400 font-bold uppercase tracking-widest">Compromiso Arte-Sano • v1.0</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-stone-100 rounded-full transition-colors text-stone-400 hover:text-stone-900"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-grow overflow-y-auto p-10 space-y-8 text-stone-600 leading-relaxed font-light">
          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <Eye size={14} className="text-amber-600" />
              <span>1. Responsable del Tratamiento</span>
            </div>
            <p className="text-sm">
              Arte-Sano Panadería Consciente, con domicilio en Cartagena, Colombia, es responsable del tratamiento de sus datos personales recolectados a través de esta plataforma.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <FileText size={14} className="text-amber-600" />
              <span>2. Datos Recolectados y Finalidad</span>
            </div>
            <p className="text-sm mb-3">
              Únicamente recolectamos su dirección de correo electrónico cuando usted decide suscribirse voluntariamente. La finalidad es:
            </p>
            <ul className="list-disc pl-5 text-sm space-y-2">
              <li>Envío de nuestro catálogo digital actualizado.</li>
              <li>Comunicación de nuevos lanzamientos y productos de temporada.</li>
              <li>Invitaciones a eventos y preventas exclusivas.</li>
            </ul>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <Lock size={14} className="text-amber-600" />
              <span>3. Seguridad y Almacenamiento</span>
            </div>
            <p className="text-sm">
              Sus datos se almacenan en servidores seguros y bajo protocolos de cifrado. Arte-Sano no vende, alquila ni comparte su información con terceros bajo ninguna circunstancia comercial.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <ShieldCheck size={14} className="text-amber-600" />
              <span>4. Sus Derechos (ARCO)</span>
            </div>
            <p className="text-sm">
              Usted tiene derecho en cualquier momento a conocer, actualizar y rectificar sus datos personales, o solicitar la eliminación definitiva de nuestra base de datos enviando un correo a <span className="font-semibold text-stone-900">pedidos@arte-sano.com</span> o haciendo clic en el enlace de baja en nuestros correos.
            </p>
          </section>

          <div className="pt-8 border-t border-stone-100">
            <p className="text-[10px] italic text-stone-400 text-center uppercase tracking-widest">
              Última actualización: Noviembre 2024
            </p>
          </div>
        </div>

        {/* Footer Action */}
        <div className="p-6 bg-stone-50 border-t border-stone-200 flex justify-center">
          <button 
            onClick={onClose}
            className="bg-stone-900 text-white px-10 py-3 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-stone-700 transition-all shadow-md active:scale-95"
          >
            Entendido y Acepto
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
